import {
	ready
} from '~/core'
ready('searchBox', '.searchBox', searchBox => {
});
